<template>
  <div
    class="mt55 pr"
    style="min-height:620px"
  >
    <div
      class="w1200"
      v-show="isShow"
    >
      <div class="head clearfix">
        <HT
          text="zlfz"
          style="margin-top:20px;float:left"
        />
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/gdyy' }">
                关于固德
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/zlfz' }">
                质量方针
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
    </div>
    <div class="content clearfix pr" />
  </div>
</template>

<script>
import HT from '@/components/h2.vue'
import { request } from '@/assets/utils/request'

export default {
    data() {
        return {
            list: [],
            isShow: true,
        }
    },
    components: {
        HT
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/ldgh.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        width: 100%;
        height: 527px;
        position: absolute;
        bottom: -80px;
        background: url('../../../assets/images/banner.jpg') center center no-repeat;
    }
    
</style>

<style>
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>